import {FacetState} from "../../models/FacetsState"

export const calculateSecondaryFilterRows = (
    consolidatedFilters: string[],
    primaryFeatFacets: FacetState[],
    secondaryFeatFacets: FacetState[],
    filterItemsCount: number,
): number => {
    const totalFilterItems = consolidatedFilters.length + primaryFeatFacets.length + secondaryFeatFacets.length
    // Adjust the total by subtracting 1 if primaryFeatFacets exist to avoid double-counting
    const adjustedFilterItems = primaryFeatFacets.length > 0 ? totalFilterItems - 1 : totalFilterItems
    // Calculate and return the total number of rows needed for displaying filters
    return Math.floor(adjustedFilterItems / (filterItemsCount + 1))
}
